"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.inject = void 0;
var fs_extra_1 = require("fs-extra");
var path_1 = require("path");
var webpack_merge_1 = require("webpack-merge");
var copy_templates_1 = __importDefault(require("../helpers/copy-templates"));
var logger_1 = __importDefault(require("../helpers/logger"));
var defaultConfig_1 = __importDefault(require("./defaultConfig"));
var chalk_1 = __importDefault(require("chalk"));
var log = logger_1.default('app:tauri');
var warn = logger_1.default('app:tauri (template)', chalk_1.default.red);
var injectConfFile = function (injectPath, _a, customConfig) {
    var force = _a.force, logging = _a.logging;
    if (customConfig === void 0) { customConfig = {}; }
    var path = path_1.join(injectPath, 'tauri.conf.json');
    if (fs_extra_1.existsSync(path) && force !== 'conf' && force !== 'all') {
        warn("tauri.conf.json found in " + path + "\n  Run `tauri init --force conf` to overwrite.");
        if (!force)
            return false;
    }
    else {
        fs_extra_1.removeSync(path);
        Object.keys(defaultConfig_1.default).forEach(function (key) {
            // Options marked `null` should be removed
            /* eslint-disable security/detect-object-injection */
            if (customConfig[key] === null) {
                // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                delete defaultConfig_1.default[key];
                // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                delete customConfig[key];
            }
            /* eslint-enable security/detect-object-injection */
        });
        var finalConf = webpack_merge_1.merge(defaultConfig_1.default, customConfig);
        fs_extra_1.writeFileSync(path, JSON.stringify(finalConf, undefined, 2));
        if (logging)
            log('Successfully wrote tauri.conf.json');
    }
};
var injectTemplate = function (injectPath, _a) {
    var force = _a.force, logging = _a.logging, tauriPath = _a.tauriPath;
    var dir = path_1.normalize(path_1.join(injectPath, 'src-tauri'));
    if (fs_extra_1.existsSync(dir) && force !== 'template' && force !== 'all') {
        warn("Tauri dir (" + dir + ") not empty.\nRun `tauri init --force template` to overwrite.");
        if (!force)
            return false;
    }
    var resolveTauriPath = function (tauriPath) {
        var resolvedPath = tauriPath.startsWith('/') || /^\S:/g.test(tauriPath)
            ? path_1.join(tauriPath, 'tauri') // we received a full path as argument
            : path_1.join('..', tauriPath, 'tauri'); // we received a relative path
        return resolvedPath.replace(/\\/g, '/');
    };
    var resolveCurrentTauriVersion = function () {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-var-requires, @typescript-eslint/no-unsafe-member-access
        var tauriManifest = require('../../../../tauri/Cargo.toml');
        var version = tauriManifest.package.version;
        return version.substring(0, version.lastIndexOf('.'));
    };
    var tauriDep = tauriPath
        ? "{ path = \"" + resolveTauriPath(tauriPath) + "\" }"
        : "{ version = \"" + resolveCurrentTauriVersion() + "\" }";
    fs_extra_1.removeSync(dir);
    copy_templates_1.default({
        source: path_1.resolve(__dirname, '../../templates/src-tauri'),
        scope: {
            tauriDep: tauriDep
        },
        target: dir
    });
    if (logging)
        log('Successfully wrote src-tauri');
};
var inject = function (injectPath, type, _a, customConfig) {
    var _b = _a.force, force = _b === void 0 ? false : _b, _c = _a.logging, logging = _c === void 0 ? false : _c, tauriPath = _a.tauriPath;
    if (typeof type !== 'string' || typeof injectPath !== 'string') {
        warn('- internal error. Required params missing.');
        return false;
    }
    if (type === 'template' || type === 'all') {
        injectTemplate(injectPath, { force: force, logging: logging, tauriPath: tauriPath });
    }
    if (type === 'conf' || type === 'all') {
        injectConfFile(path_1.join(injectPath, 'src-tauri'), { force: force, logging: logging }, customConfig);
    }
    return true;
};
exports.inject = inject;
